const RequestHelpers = {
    encode: (encodable: string | object) => {
        const buffer = Buffer.from(JSON.stringify(encodable));

        return buffer.toString('base64');
    },

    decode: (decodable: string) => {
        const buffer = Buffer.from(decodable, 'base64');

        return JSON.parse(buffer.toString());
    },
};

export { RequestHelpers };
